import { useState } from "react";
export default function LoginForm({ onSubmit, loading }) {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  return (
    <div className="login">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit({ id, password });
        }}
        className="loginform"
      >
        <div id="content_title">
          <h2>登录</h2>
        </div>
        <p>用户名</p>
        <input className="input_id" placeholder="请输入用户名" value={id} onChange={(e) => setId(e.target.value)} />
        <p>密码</p>
        <input className="input_pw" type="password" placeholder="请输入密码" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="loginsubmit" disabled={loading}>
            {loading ? "登录中..." : "登录"}
        </button>
        <div className="join_link"><a href="/cn/signup">注册</a></div>
      </form>
    </div>
  );
}
